export default __webpack_public_path__ + "static/sc-dev-71fccc9129bec9f6a9c1d368ff208d9e.webp";